// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===============================
   PREMIUM ABOUT SECTION - STAGGERED GRID
=============================== */

.about-section {
    padding: 120px 0;
    position: relative;
    overflow: hidden;
}

/* ===============================
   SECTION HEADER
=============================== */

.section-header {
    text-align: center;
    margin-bottom: 100px;
    animation: fadeInUp 0.8s ease-out;
}

.section-badge {
    display: inline-block;
    padding: 8px 20px;
    background: rgba(99, 102, 241, 0.15);
    border: 1px solid rgba(139, 92, 246, 0.4);
    border-radius: 50px;
    color: rgba(255, 255, 255, 0.95);
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 24px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);
}

.section-title {
    font-size: clamp(2rem, 4vw, 3.5rem);
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 16px;
    letter-spacing: -0.02em;
    line-height: 1.2;
}

.gradient-text {
    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ===============================
   ABOUT GRID - STAGGERED LAYOUT
=============================== */

.about-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px 60px;
    max-width: 1100px;
    margin: 0 auto;
}

/* ===============================
   ABOUT CARD - DIAGONAL SLICE DESIGN
=============================== */

.about-card {
    position: relative;
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.08), rgba(168, 85, 247, 0.04));
    border-left: 3px solid transparent;
    border-image: linear-gradient(to bottom, #6366f1, #a855f7) 1;
    padding: 40px 36px;
    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
    overflow: hidden;
    animation: fadeInUp 0.6s ease-out both;
    clip-path: polygon(0 0, 100% 0, 100% calc(100% - 15px), calc(100% - 15px) 100%, 0 100%);
}

.about-card[data-index="0"] { 
    animation-delay: 0.1s;
    transform: translateY(-20px);
}
.about-card[data-index="1"] { 
    animation-delay: 0.2s;
    transform: translateY(20px);
}
.about-card[data-index="2"] { 
    animation-delay: 0.3s;
    transform: translateY(-20px);
}
.about-card[data-index="3"] { 
    animation-delay: 0.4s;
    transform: translateY(20px);
}
.about-card[data-index="4"] { 
    animation-delay: 0.5s;
    transform: translateY(-20px);
}
.about-card[data-index="5"] { 
    animation-delay: 0.6s;
    transform: translateY(20px);
}

.about-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(168, 85, 247, 0.08));
    opacity: 0;
    transition: opacity 0.5s ease;
}

.about-card:hover::before {
    opacity: 1;
}

.about-card:hover {
    transform: translateY(0) translateX(10px);
    border-left-width: 5px;
    box-shadow: 
        -10px 20px 60px rgba(99, 102, 241, 0.25),
        0 0 60px rgba(168, 85, 247, 0.15);
}

/* ===============================
   CARD NUMBER
=============================== */

.card-number-large {
    font-size: 5rem;
    font-weight: 900;
    background: linear-gradient(135deg, #6366f1, #a855f7);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    opacity: 0.15;
    margin-bottom: 20px;
    line-height: 1;
    transition: all 0.5s ease;
    position: relative;
    z-index: 1;
}

.about-card:hover .card-number-large {
    opacity: 0.25;
    transform: scale(1.1) translateX(10px);
}

/* ===============================
   CARD CONTENT
=============================== */

.card-content {
    position: relative;
    z-index: 2;
}

.about-card-title {
    font-size: 1.625rem;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 16px;
    line-height: 1.3;
    transition: all 0.3s ease;
}

.about-card:hover .about-card-title {
    background: linear-gradient(135deg, #818cf8, #c084fc);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.about-card-desc {
    font-size: 1.0625rem;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.8;
    margin: 0;
}

/* ===============================
   ACCENT LINE
=============================== */

.card-gradient-line {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    height: 4px;
    background: linear-gradient(90deg, 
        transparent,
        rgba(99, 102, 241, 0.6),
        rgba(168, 85, 247, 0.6),
        transparent
    );
    opacity: 0;
    transition: opacity 0.5s ease;
}

.about-card:hover .card-gradient-line {
    opacity: 1;
}

/* ===============================
   HOVER GLOW
=============================== */

.card-hover-glow {
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, 
        rgba(99, 102, 241, 0.15), 
        transparent 60%
    );
    opacity: 0;
    transition: opacity 0.5s ease;
    pointer-events: none;
    z-index: 0;
}

.about-card:hover .card-hover-glow {
    opacity: 1;
}

/* ===============================
   RESPONSIVE
=============================== */

@media (max-width: 992px) {
    .about-grid {
        grid-template-columns: 1fr;
        gap: 40px;
    }

    .about-card[data-index="0"],
    .about-card[data-index="1"],
    .about-card[data-index="2"],
    .about-card[data-index="3"],
    .about-card[data-index="4"],
    .about-card[data-index="5"] {
        transform: translateY(0);
    }

    .about-card:hover {
        transform: translateX(15px);
    }
}

@media (max-width: 768px) {
    .about-section {
        padding: 80px 0;
    }

    .section-header {
        margin-bottom: 70px;
    }

    .about-card {
        padding: 32px 28px;
    }

    .card-number-large {
        font-size: 3.5rem;
        margin-bottom: 16px;
    }

    .about-card-title {
        font-size: 1.375rem;
    }

    .about-card-desc {
        font-size: 0.9375rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/AboutSection.css"],"names":[],"mappings":"AAAA;;iCAEiC;;AAEjC;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;iCAEiC;;AAEjC;IACI,kBAAkB;IAClB,oBAAoB;IACpB,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oCAAoC;IACpC,yCAAyC;IACzC,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,8DAA8D;IAC9D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;iCAEiC;;AAEjC;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;iCAEiC;;AAEjC;IACI,kBAAkB;IAClB,uFAAuF;IACvF,kCAAkC;IAClC,4DAA4D;IAC5D,kBAAkB;IAClB,kDAAkD;IAClD,gBAAgB;IAChB,sCAAsC;IACtC,uFAAuF;AAC3F;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;AAChC;AACA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;AACA;IACI,qBAAqB;IACrB,4BAA4B;AAChC;AACA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;AACA;IACI,qBAAqB;IACrB,4BAA4B;AAChC;AACA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,uFAAuF;IACvF,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yCAAyC;IACzC,sBAAsB;IACtB;;yCAEqC;AACzC;;AAEA;;iCAEiC;;AAEjC;IACI,eAAe;IACf,gBAAgB;IAChB,qDAAqD;IACrD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sCAAsC;AAC1C;;AAEA;;iCAEiC;;AAEjC;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,qDAAqD;IACrD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,+BAA+B;IAC/B,gBAAgB;IAChB,SAAS;AACb;;AAEA;;iCAEiC;;AAEjC;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,OAAO;IACP,WAAW;IACX;;;;;KAKC;IACD,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;;iCAEiC;;AAEjC;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ;;;KAGC;IACD,UAAU;IACV,6BAA6B;IAC7B,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;iCAEiC;;AAEjC;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;;;;;;QAMI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":["/* ===============================\n   PREMIUM ABOUT SECTION - STAGGERED GRID\n=============================== */\n\n.about-section {\n    padding: 120px 0;\n    position: relative;\n    overflow: hidden;\n}\n\n/* ===============================\n   SECTION HEADER\n=============================== */\n\n.section-header {\n    text-align: center;\n    margin-bottom: 100px;\n    animation: fadeInUp 0.8s ease-out;\n}\n\n.section-badge {\n    display: inline-block;\n    padding: 8px 20px;\n    background: rgba(99, 102, 241, 0.15);\n    border: 1px solid rgba(139, 92, 246, 0.4);\n    border-radius: 50px;\n    color: rgba(255, 255, 255, 0.95);\n    font-size: 0.875rem;\n    font-weight: 600;\n    margin-bottom: 24px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);\n}\n\n.section-title {\n    font-size: clamp(2rem, 4vw, 3.5rem);\n    font-weight: 700;\n    color: #ffffff;\n    margin-bottom: 16px;\n    letter-spacing: -0.02em;\n    line-height: 1.2;\n}\n\n.gradient-text {\n    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* ===============================\n   ABOUT GRID - STAGGERED LAYOUT\n=============================== */\n\n.about-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 40px 60px;\n    max-width: 1100px;\n    margin: 0 auto;\n}\n\n/* ===============================\n   ABOUT CARD - DIAGONAL SLICE DESIGN\n=============================== */\n\n.about-card {\n    position: relative;\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.08), rgba(168, 85, 247, 0.04));\n    border-left: 3px solid transparent;\n    border-image: linear-gradient(to bottom, #6366f1, #a855f7) 1;\n    padding: 40px 36px;\n    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n    overflow: hidden;\n    animation: fadeInUp 0.6s ease-out both;\n    clip-path: polygon(0 0, 100% 0, 100% calc(100% - 15px), calc(100% - 15px) 100%, 0 100%);\n}\n\n.about-card[data-index=\"0\"] { \n    animation-delay: 0.1s;\n    transform: translateY(-20px);\n}\n.about-card[data-index=\"1\"] { \n    animation-delay: 0.2s;\n    transform: translateY(20px);\n}\n.about-card[data-index=\"2\"] { \n    animation-delay: 0.3s;\n    transform: translateY(-20px);\n}\n.about-card[data-index=\"3\"] { \n    animation-delay: 0.4s;\n    transform: translateY(20px);\n}\n.about-card[data-index=\"4\"] { \n    animation-delay: 0.5s;\n    transform: translateY(-20px);\n}\n.about-card[data-index=\"5\"] { \n    animation-delay: 0.6s;\n    transform: translateY(20px);\n}\n\n.about-card::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(168, 85, 247, 0.08));\n    opacity: 0;\n    transition: opacity 0.5s ease;\n}\n\n.about-card:hover::before {\n    opacity: 1;\n}\n\n.about-card:hover {\n    transform: translateY(0) translateX(10px);\n    border-left-width: 5px;\n    box-shadow: \n        -10px 20px 60px rgba(99, 102, 241, 0.25),\n        0 0 60px rgba(168, 85, 247, 0.15);\n}\n\n/* ===============================\n   CARD NUMBER\n=============================== */\n\n.card-number-large {\n    font-size: 5rem;\n    font-weight: 900;\n    background: linear-gradient(135deg, #6366f1, #a855f7);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    opacity: 0.15;\n    margin-bottom: 20px;\n    line-height: 1;\n    transition: all 0.5s ease;\n    position: relative;\n    z-index: 1;\n}\n\n.about-card:hover .card-number-large {\n    opacity: 0.25;\n    transform: scale(1.1) translateX(10px);\n}\n\n/* ===============================\n   CARD CONTENT\n=============================== */\n\n.card-content {\n    position: relative;\n    z-index: 2;\n}\n\n.about-card-title {\n    font-size: 1.625rem;\n    font-weight: 700;\n    color: #ffffff;\n    margin-bottom: 16px;\n    line-height: 1.3;\n    transition: all 0.3s ease;\n}\n\n.about-card:hover .about-card-title {\n    background: linear-gradient(135deg, #818cf8, #c084fc);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.about-card-desc {\n    font-size: 1.0625rem;\n    color: rgba(255, 255, 255, 0.8);\n    line-height: 1.8;\n    margin: 0;\n}\n\n/* ===============================\n   ACCENT LINE\n=============================== */\n\n.card-gradient-line {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    height: 4px;\n    background: linear-gradient(90deg, \n        transparent,\n        rgba(99, 102, 241, 0.6),\n        rgba(168, 85, 247, 0.6),\n        transparent\n    );\n    opacity: 0;\n    transition: opacity 0.5s ease;\n}\n\n.about-card:hover .card-gradient-line {\n    opacity: 1;\n}\n\n/* ===============================\n   HOVER GLOW\n=============================== */\n\n.card-hover-glow {\n    position: absolute;\n    top: -50%;\n    left: -50%;\n    width: 200%;\n    height: 200%;\n    background: radial-gradient(circle, \n        rgba(99, 102, 241, 0.15), \n        transparent 60%\n    );\n    opacity: 0;\n    transition: opacity 0.5s ease;\n    pointer-events: none;\n    z-index: 0;\n}\n\n.about-card:hover .card-hover-glow {\n    opacity: 1;\n}\n\n/* ===============================\n   RESPONSIVE\n=============================== */\n\n@media (max-width: 992px) {\n    .about-grid {\n        grid-template-columns: 1fr;\n        gap: 40px;\n    }\n\n    .about-card[data-index=\"0\"],\n    .about-card[data-index=\"1\"],\n    .about-card[data-index=\"2\"],\n    .about-card[data-index=\"3\"],\n    .about-card[data-index=\"4\"],\n    .about-card[data-index=\"5\"] {\n        transform: translateY(0);\n    }\n\n    .about-card:hover {\n        transform: translateX(15px);\n    }\n}\n\n@media (max-width: 768px) {\n    .about-section {\n        padding: 80px 0;\n    }\n\n    .section-header {\n        margin-bottom: 70px;\n    }\n\n    .about-card {\n        padding: 32px 28px;\n    }\n\n    .card-number-large {\n        font-size: 3.5rem;\n        margin-bottom: 16px;\n    }\n\n    .about-card-title {\n        font-size: 1.375rem;\n    }\n\n    .about-card-desc {\n        font-size: 0.9375rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
